<!-- FinishAdditionalDocsPage -->
<template>
    <div class="container ps-lg-5 pe-lg-5">
        <div class="row">
            <div class="col-12 col-lg-12 mt-lg-5 text-center">
                <div class="icon-thankyou">
                    <img src="@/assets/images/icon-thankyou.svg" class="w-100" />
                </div>
                <h1 class="blue-1 fw-normal">THANK YOU</h1>
                <h3 class="blue-1 fw-normal name font-family">
                    เรียนคุณ {{ this.$store.state.UserName }}
                </h3>
                <div class="content pt-lg-3 fw-normal font-family fs-4">
                    <p style="margin-bottom: 0rem">
                        ท่านได้ทำการส่งข้อมูลคำร้องขอ<span class="blue-1">ส่งเอกสารเพิ่มเติม</span>เรียบร้อยแล้ว<br>
                        ข้อมูลดังกล่าว จะยังไม่ได้รับการอัปเดตจนกว่าเจ้าหน้าที่จะทำการตรวจสอบ </p>
                </div>
                <div class="col-12">
                    <div class="row">
                        <div class="col-2 col-sm-4"></div>
                        <div class="col font-family fs-4">
                            <p style="margin-bottom: 0rem">
                                ท่านสามารถติดตามสถานะของรายการได้จาก
                            </p>
                            <ul class="">
                                <li>ระบบ Agency E-Request เมนู ประวัติการแก้ไข</li>
                            </ul>
                        </div>
                        <div class="col-2 col-sm-4"></div>
                    </div>
                </div>
                <div class="content pt-lg-2 fw-normal fs-4">
                    <p class="font-family" style="margin-bottom: 0rem">
                        หากท่านมีข้อสงสัยกรุณาติดต่อ
                    </p>
                    <p class="font-family" style="margin-bottom: 0rem">
                        ส่วนสัญญาตัวแทน บมจ.กรุงเทพประกันชีวิต
                    </p>
                    <p class="blue-1 fw-bold fs-6">โทร. 02-777-{{ dataShow.contact }}</p>
                </div>
                <div class="mt-lg-4 mb-lg-4 d-none d-none d-lg-block">
                    <router-link to="/AgenteService" class="btn-back fw-normal font-family text-decoration-none">
                        กลับไปหน้าแรก </router-link>
                </div>
                <router-link to="/AgenteService"
                    class="btn-back mt-1 mb-2 fw-normal d-lg-none font-family text-decoration-none"> กลับไปหน้าแรก
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "FinishPage",

    data() {
        return {
            CONFIG: {
                nameEN: {
                    description: 'ชื่อ-นามสกุล (ภาษาอังกฤษ)',
                    contact: '8556'
                },
                addr: {
                    description: 'ที่อยู่',
                    contact: '8556'
                },
                accBank: {
                    description: 'บัญชีธนาคาร',
                    contact: '8556'
                },
                vat: {
                    description: 'บันทึก VAT',
                    contact: '8558'
                },
                aoe: {
                    description: 'ขอแต่งตั้งตำแหน่ง (ผู้บริหารหน่วยดำเนินการ)',
                    contact: '8567'
                },
                oep: {
                    description: 'ขอเปลี่ยนแปลงตำแหน่ง(ผู้บริหารหน่วยดำเนินการ)-เลื่อนตำแหน่ง',
                    contact: '8567'
                },
                oed: {
                    description: 'ขอเปลี่ยนแปลงตำแหน่ง(ผู้บริหารหน่วยดำเนินการ)-ลดตำแหน่ง',
                    contact: '8567'
                },
                tsaoe: {
                    description: 'ขอโอนตัวแทนใต้สังกัด(ผู้บริหารหน่วยดำเนินการ)',
                    contact: '8567'
                },
                btoe: {
                    description: 'แจ้งย้ายสาขา(ผู้บริหารหน่วยดำเนินการ)',
                    contact: '8567'
                },
                btoa: {
                    description: 'ขอย้ายสาขา(ตัวแทนดำเนินการ)',
                    contact: '8567'
                },
                tp: {
                    description: 'ขอโอนผลงาน',
                    contact: '8556'
                },
                racth: {
                    description: 'ขอหนังสือรับรองการทำงานภาษาไทย',
                    contact: '8553'
                },
                racenni: {
                    description: 'ขอหนังสือรับรองการทำงานภาษาอังกฤษ แบบไม่ระบุรายได้',
                    contact: '8553'
                },
                raceni2: {
                    description: 'ขอหนังสือรับรองการทำงานภาษาอังกฤษ (ระบุรายได้ของปีนี้ และปีที่แล้ว)',
                    contact: '8553'
                },
                racenic: {
                    description: 'ขอหนังสือรับรองการทำงานภาษาอังกฤษ (ระบุรายได้เฉพาะของปีนี้)',
                    contact: '8553'
                },
                rabc: {
                    description: 'ขอพิมพ์นามบัตร',
                    contact: '8558'
                },
                rar: {
                    description: 'ขอลาออก',
                    contact: '8953'
                },
                bac: {
                    description: 'ขอทำบัตรประจำตัวผ่านเข้าออกอาคารสำนักงาน',
                    contact: '8552'
                },
            },
            dataShow: {
                description: '',
                contact: ''
            }
        }
    },

    mounted() {
        const type = this.$route.query.type

        if (this.CONFIG[type]) {
            this.dataShow = this.CONFIG[type]
        } else {
            this.dataShow = {
                description: 'ไม่พบข้อมูล',
                contact: '-'
            }
        }
    }
}
</script>

<style scoped>
.name {
    font-size: 30px;
    font-size: 1.875rem;
}
</style>